export {default} from './CohostClubChat';



// WEBPACK FOOTER //
// ./src/pages/CohostClubChat/index.ts